<template>
  <b-row>
    <b-col>
      <b-container fluid>
        <b-row class="mt-5">
          <b-col cols="12" md="6">
            <p class="mb-5">КОМУНАЛЬНЕ ПІДПРИЄМСТВО «БЮРО ТЕХНІЧНОЇ ІНВЕНТАРИЗАЦІЇ» ОДЕСЬКОЇ МІСЬКОЇ РАДИ</p>
            <p>Панель адміністратора</p>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'StartTemplate',
}
</script>